export default {
  goal: 'Accéder au parcours de conseil fiscalité',
  title: 'Vos impôts',
  label: 'Vos impôts',
}
